import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

BSeparator.propTypes = {
  className: PropTypes.string,  // necessaire pour styled
};

function BSeparator({className}){
  return <div className={className}>*</div>;
}

const Separator = styled(BSeparator)`
  display: block;
  text-align: center;
  margin: 0.5em auto;
  text-decoration: none;
  font-weight: bold;
  font-style: normal;
`;

export default Separator;